import { createClient } from '@supabase/supabase-js'

// Função para testar a conexão com o Supabase
export const testSupabaseConnection = async () => {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

  console.log('🔍 Testando conexão com Supabase...')
  console.log('URL:', supabaseUrl)
  console.log('Chave anônima:', supabaseAnonKey ? 'Configurada' : 'NÃO CONFIGURADA')

  if (!supabaseUrl || !supabaseAnonKey) {
    console.error('❌ Variáveis de ambiente não configuradas!')
    return {
      success: false,
      error: 'Variáveis de ambiente VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY não estão configuradas'
    }
  }

  try {
    const supabase = createClient(supabaseUrl, supabaseAnonKey)
    
    // Teste básico de conexão
    const { data, error } = await supabase.from('profiles').select('count').limit(1)
    
    if (error) {
      console.error('❌ Erro na conexão:', error)
      return {
        success: false,
        error: error.message
      }
    }

    console.log('✅ Conexão com Supabase estabelecida com sucesso!')
    return {
      success: true,
      data
    }
  } catch (error) {
    console.error('❌ Erro inesperado:', error)
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Erro desconhecido'
    }
  }
}

// Função para testar registro
export const testRegistration = async (email: string, password: string, name: string) => {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

  if (!supabaseUrl || !supabaseAnonKey) {
    return {
      success: false,
      error: 'Variáveis de ambiente não configuradas'
    }
  }

  try {
    const supabase = createClient(supabaseUrl, supabaseAnonKey)
    
    console.log('🔍 Testando registro...')
    
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          name: name
        }
      }
    })
    
    if (error) {
      console.error('❌ Erro no registro:', error)
      return {
        success: false,
        error: error.message
      }
    }

    console.log('✅ Registro testado com sucesso!')
    return {
      success: true,
      data
    }
  } catch (error) {
    console.error('❌ Erro inesperado no registro:', error)
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Erro desconhecido'
    }
  }
}
